const getComposerFocusSurface = (value) => {
  const normalizedValue = String(value || '')
    .trim()
    .toLowerCase();

  if (normalizedValue === 'schedule' || normalizedValue === 'schedule_run') {
    return 'schedule';
  }

  if (normalizedValue === 'trigger' || normalizedValue === 'trigger_run') {
    return 'trigger';
  }

  if (normalizedValue === 'workflow') {
    return 'workflow';
  }

  return 'main';
};

export default getComposerFocusSurface;
